import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';

import App from 'pages/app';
import MainContainer from 'pages/mainContainer';
import Authentication from 'pages/authentication/authentication';
import Login from 'pages/authentication/login';
import AuthenticationNew from 'pages/authentication/authenticationNew';
import SsoLogin from 'pages/authentication/ssoLogin';
import SsoError from 'pages/authentication/ssoError';

import TaskPage from 'pages/mobile/taskPage';
import TaskViewForm from 'modules/task/mobile/viewForm';
import TaskEditForm from 'modules/task/mobile/editForm';
import JobPage from 'pages/mobile/jobPage';
import JobNew from 'pages/mobile/jobNew';
import JobNewTaskForm from 'modules/job/mobile/newTaskForm';
import JobViewForm from 'modules/job/mobile/viewForm';
import JobEditForm from 'modules/job/mobile/editForm';

import ArchiveTask from 'pages/mobile/archive/taskPage';
import ArchiveJob from 'pages/mobile/archive/jobPage';

import NotificationPage from 'pages/mobile/notificationPage';

import PageNotFound from 'pages/pageNotFound';

const routes = (
  <Routes>
    <Route element={<App />}>
      <Route element={<Navigate replace to="/auth/login" />} path="/auth" />
      <Route element={<Navigate replace to="/tasks" />} path="/home" />
      <Route element={<Navigate replace to="/tasks" />} path="/" />
      <Route element={<Navigate replace to="/archives/tasks" />} path="/archives" />

      <Route
        element={(
          <Authentication>
            <Login />
          </Authentication>
        )}
        path="/auth/login"
      />

      <Route element={<AuthenticationNew />} path="/auth/login/sso/*">
        <Route element={<SsoError />} path=":domain/error" />
        <Route element={<SsoLogin />} path=":domain" />
        <Route element={<PageNotFound />} path="*" />
      </Route>

      <Route
        element={(
          <MainContainer>
            <TaskPage />
          </MainContainer>
        )}
        path="/tasks"
      />

      <Route
        element={(
          <MainContainer>
            <TaskPage>
              <TaskViewForm />
            </TaskPage>
          </MainContainer>
        )}
        path="/tasks/:id"
      />

      <Route
        element={(
          <MainContainer editOnly>
            <TaskPage>
              <TaskEditForm />
            </TaskPage>
          </MainContainer>
        )}
        path="/tasks/:id/edit"
      />

      <Route
        element={(
          <MainContainer>
            <JobPage />
          </MainContainer>
        )}
        path="/jobs"
      />

      <Route
        element={(
          <MainContainer>
            <JobPage>
              <JobNew />
            </JobPage>
          </MainContainer>
        )}
        path="/jobs/new"
      />

      <Route
        element={(
          <MainContainer>
            <JobPage>
              <JobViewForm />
            </JobPage>
          </MainContainer>
        )}
        path="/jobs/:id"
      />

      <Route
        element={(
          <MainContainer editOnly>
            <JobPage>
              <JobNewTaskForm />
            </JobPage>
          </MainContainer>
        )}
        path="/jobs/:id/new_task"
      />

      <Route
        element={(
          <MainContainer editOnly>
            <JobPage>
              <JobEditForm />
            </JobPage>
          </MainContainer>
        )}
        path="/jobs/:id/edit"
      />

      <Route
        element={(
          <MainContainer>
            <ArchiveTask />
          </MainContainer>
        )}
        path="/archives/tasks"
      />

      <Route
        element={(
          <MainContainer>
            <ArchiveTask>
              <TaskViewForm />
            </ArchiveTask>
          </MainContainer>
        )}
        path="/archives/tasks/:id"
      />

      <Route
        element={(
          <MainContainer editOnly>
            <ArchiveTask>
              <TaskEditForm />
            </ArchiveTask>
          </MainContainer>
        )}
        path="/archives/tasks/:id/edit"
      />

      <Route
        element={(
          <MainContainer>
            <ArchiveJob />
          </MainContainer>
        )}
        path="/archives/jobs"
      />

      <Route
        element={(
          <MainContainer>
            <ArchiveJob>
              <JobViewForm />
            </ArchiveJob>
          </MainContainer>
        )}
        path="/archives/jobs/:id"
      />

      <Route
        element={(
          <MainContainer editOnly>
            <ArchiveJob>
              <JobEditForm />
            </ArchiveJob>
          </MainContainer>
        )}
        path="/archives/jobs/:id/edit"
      />

      <Route
        element={(
          <MainContainer>
            <NotificationPage />
          </MainContainer>
        )}
        path="/notifications"
      />

      <Route element={<PageNotFound />} path="*" />
    </Route>
  </Routes>
);

export default routes;
